const precisionMedium = `
precision mediump float;
`;
export default precisionMedium.replace(/\n/g, '');